
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/plain-tab-control",
      function () {
        return require("private-next-pages/design-system/plain-tab-control.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/plain-tab-control"])
      });
    }
  